import React from "react";

import { StyledBadge } from "./styled";
import type { BadgeProps } from "./types";

export const Badge: React.FC<BadgeProps> = ({
  children,
  size = "medium",
  variant = "solid",
  className,
  testId,
  styleProps,
  ...props
}) => {
  return (
    <StyledBadge
      $size={size}
      $variant={variant}
      $styleProps={styleProps}
      {...(className && { className })}
      data-testid={testId}
      {...props}
    >
      {children}
    </StyledBadge>
  );
};
